class VideoCategoryData {

    constructor(result) {

        this.categoryId = String(result.category_id).trim();
        this.categoryName = String(result.category_name).trim();
        this.categorySource = String(result.category_source).trim();
        this.categoryImageId = String(result.category_image_id).trim();
        this.categoryVideos = +(result.category_videos);
        this.categoryState = String(result.category_state).trim();

    }

    getLabel() {

        return this.category_name ? this.category_name : this.category_id;

    }

}

export default VideoCategoryData;